import type { NewsItem } from '@/types/content';

export const newsItems: NewsItem[] = [
  {
    id: 'frieren-s2',
    title: '《葬送的芙莉莲》第二季正式定档，全新主视觉公开',
    date: '2026-10-15',
    author: '琉璃神社编辑部',
    section: '热门',
    summary:
      '官方于今日公开第二季首张主视觉与定档信息，故事将从“黄金乡”篇章继续，制作阵容基本延续第一季原班人马。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20an%20elf%20mage%20with%20white%20hair%20standing%20in%20a%20windswept%20grassland%20at%20golden%20hour%2C%20tall%20grass%20bending%2C%20distant%20mountains%2C%20soft%20teal%20sky%20with%20warm%20amber%20sunlight%2C%20painterly%20digital%20art%2C%20cinematic%20composition%2C%20gentle%20atmospheric%20haze%2C%20clean%20simple%20background&width=800&height=600&seq=news-frieren-01&orientation=landscape',
    tags: ['新番情报', '奇幻', '定档'],
    views: 18420,
    quote: '“时间对精灵而言几乎静止，正因如此，每一次告别都值得被认真记录。”',
    content: [
      '官方于今日午间公开了《葬送的芙莉莲》第二季的首张主视觉与播出窗口。画面中芙莉莲独自站在草原尽头，远处是熟悉的山脉轮廓，团队在配文中写道：“旅途仍将继续，只是这一次，我们要走得更慢一些。”',
      '据制作委员会披露，第二季将承接第一季结尾的时间线，重点改编原作中篇幅最长的“黄金乡”篇章。监督与系列构成均沿用原班阵容，音乐部分继续由 Evan Call 负责，制作公司维持原有班底。',
      '值得关注的是，本次公开的视觉图刻意弱化了战斗元素，转而强调旅途中的日常感。制作人在采访中提到，第二季会花更多篇幅描绘“人与人之间的时间差”，这也与作品一贯的物哀气质相呼应。播出时间预计落在明年春季档。',
    ],
  },
  {
    id: 'kyoani-film',
    title: '京都动画新作剧场版公布首个预告，明年夏天上映',
    date: '2026-10-12',
    author: '琉璃神社编辑部',
    section: '最新',
    summary:
      '新作延续京都动画擅长的日常题材，以一間老式商店街为舞台，首支预告片长约一分四十秒。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20Kyoto%20animation%20studio%20street%20at%20dusk%2C%20warm%20lit%20windows%2C%20bicycles%20leaning%20against%20wooden%20walls%2C%20sakura%20petals%20in%20the%20air%2C%20teal%20shadow%20tones%20with%20orange%20lamp%20glow%2C%20hand%20painted%20digital%20art%2C%20quiet%20nostalgic%20mood%2C%20cinematic%20depth&width=800&height=600&seq=news-kyoani-street&orientation=landscape',
    tags: ['剧场版', '京都动画', '预告'],
    views: 15260,
    quote: '“商店街的灯一盏盏亮起来的时候，故事就开始了。”',
    content: [
      '京都动画在今日举行的作品发布会上公开了新作剧场版的首支预告。预告以一个长镜头开场：傍晚的商店街，卷帘门被拉下，路灯依次亮起，少女骑着自行车穿过整条街道。',
      '官方说明新作将以“地方商店街的消失”为背景，讲述几名高中生在毕业前试图办一场夏日祭典的故事。全片时长约 108 分钟，采用手绘为主、数字辅助的制作方式，背景美术团队为此在京都实地取景超过三个月。',
      '预告片上线三小时内播放量突破百万，评论区里出现最多的一句话是“这就是我想念的夏天”。影片定于明年七月在日本本土上映，海外发行计划正在洽谈中。',
    ],
  },
  {
    id: 'dungeon-meshi-final',
    title: '《迷宫饭》漫画正式完结，官方推出纪念画集',
    date: '2026-10-09',
    author: '琉璃神社编辑部',
    section: '最新',
    summary:
      '连载近十年的作品迎来最终话，官方同步公布厚达 240 页的纪念画集与作者长篇访谈。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20cozy%20fantasy%20dungeon%20dining%20table%20with%20a%20steaming%20monster%20soup%20pot%2C%20mushrooms%2C%20bread%20and%20wooden%20bowls%2C%20warm%20orange%20candlelight%2C%20teal%20stone%20walls%2C%20appetizing%20detailed%20food%20illustration%2C%20hand%20painted%20digital%20art%2C%20clean%20simple%20composition&width=800&height=600&seq=news-dungeon-table&orientation=landscape',
    tags: ['漫画完结', '奇幻', '画集'],
    views: 13980,
    quote: '“吃饭这件事，本身就是对活着最诚实的确认。”',
    content: [
      '《迷宫饭》在本周发售的杂志上刊登了最终话，结束了自 2016 年开始的近十年连载。最终话以一顿再普通不过的晚餐收尾，没有大规模战斗，也没有煽情独白，只有一口热汤和一句“很好吃”。',
      '官方同步宣布推出 240 页的纪念画集，收录连载期间的全部彩页、单行本未使用封面草稿，以及作者九井谅子的长篇访谈。访谈中她提到，作品的起点其实是“如果迷宫里有完整的生态系统会怎样”这个单纯的疑问。',
      '对于动画观众关心的续篇问题，出版社回应称“目前没有可以公布的消息”，但也强调作者本人对后续改编持开放态度。画集将于下月中旬发售，首批附赠迷宫饭谱主题的餐桌垫。',
    ],
  },
  {
    id: 'autumn-2026-lineup',
    title: '2026 秋季新番前瞻：36 部作品一览',
    date: '2026-10-06',
    author: '琉璃神社编辑部',
    section: '专题报道',
    summary:
      '从续作大户到原创黑马，我们整理了这个秋天值得关注的 36 部作品，并按类型做了分组梳理。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20four%20colorful%20anime%20season%20key%20visuals%20arranged%20as%20floating%20posters%20in%20a%20teal%20night%20sky%20with%20glowing%20amber%20highlights%2C%20abstract%20layered%20composition%2C%20editorial%20magazine%20cover%20feel%2C%20painterly%20digital%20art%2C%20clean%20background%20with%20subtle%20grain&width=800&height=600&seq=news-autumn-lineup&orientation=landscape',
    tags: ['新番', '专题', '导览'],
    views: 22410,
    quote: '“续作负责安全感，原创负责惊喜。”',
    content: [
      '今年秋季档共有 36 部电视动画开播，其中续作与改编作品占到七成。从数量上看依旧是奇幻与异世界占优，但真正被讨论最多的，反而是几部体量不大的原创作品。',
      '续作方面，《葬送的芙莉莲》第二季、《赛博朋克：边缘行者》续篇与《咒术回战》最终章构成最受关注的三条主线。改编方面则出现了较多女性向与日常系作品，整体口味比去年更加分散。',
      '原创阵容里，有两部作品值得提前记下名字：一部以战后昭和时期的电影院为舞台，另一部讲述城市中“声音采集师”的日常。它们都没有强设定的噱头，却在预告阶段就展现出清晰的作者性。',
    ],
  },
  {
    id: 'edgerunners-sequel',
    title: '《赛博朋克：边缘行者》续作确认制作中',
    date: '2026-09-30',
    author: '琉璃神社编辑部',
    section: '热门',
    summary:
      '官方社交账号发布一段十秒的霓虹短片，确认新作进入制作阶段，故事舞台将转移至新的城市。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20cyberpunk%20illustration%20of%20a%20neon%20soaked%20night%20alley%20with%20rain%20reflections%2C%20a%20lone%20figure%20in%20a%20bright%20jacket%20seen%20from%20behind%2C%20magenta%20and%20amber%20signage%20against%20deep%20teal%20shadows%2C%20cinematic%20wide%20shot%2C%20painterly%20digital%20art%2C%20atmospheric%20fog&width=800&height=600&seq=news-cyberpunk-alley&orientation=landscape',
    tags: ['续作', '赛博朋克', '制作决定'],
    views: 26730,
    quote: '“霓虹灯下没有新鲜事，只有新的名字。”',
    content: [
      '官方在社交平台发布了一段十秒短片：雨夜、霓虹、一个背影走进巷子深处，最后画面定格在一行字——“NEW CITY, NEW GHOST”。随后确认续作已进入制作阶段。',
      '与前作聚焦夜之城不同，新作将把舞台搬到另一座沿海都市，制作团队表示希望借由“更潮湿、更明亮”的城市气质，讨论资本与身体的另一种关系。前作的核心主创将以监修身份参与。',
      '这条消息发布后，相关话题在两小时内登上多个平台热搜。观众最关心的问题依旧是音乐：官方只回应“会有熟悉的声音”，并未公布具体名单。',
    ],
  },
  {
    id: 'hanazawa-tour',
    title: '声优花泽香菜宣布举办个人巡回演唱会',
    date: '2026-09-26',
    author: '琉璃神社编辑部',
    section: '最新',
    summary: '巡演将覆盖东京、大阪、名古屋等五座城市，曲目以近十年的角色歌曲与个人作品为主。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20singer%20on%20a%20small%20glowing%20stage%20holding%20a%20vintage%20microphone%2C%20warm%20spotlight%20beams%2C%20floating%20music%20notes%2C%20teal%20curtain%20backdrop%2C%20sparkling%20dust%20in%20the%20air%2C%20hand%20painted%20digital%20art%2C%20elegant%20concert%20atmosphere%2C%20clean%20composition&width=800&height=600&seq=news-seiyuu-stage&orientation=landscape',
    tags: ['声优', '演唱会', '活动'],
    views: 9840,
    quote: '“角色的声音，也是我自己的一部分。”',
    content: [
      '声优花泽香菜于个人频道宣布启动新一轮巡回演唱会，覆盖东京、大阪、名古屋、福冈与札幌五座城市，共计八场演出。',
      '本次巡演的主题为“回声”，曲目将横跨她近十年的角色歌曲与个人专辑作品，部分曲目会以重新编曲的乐队版本呈现。舞台设计由曾参与多个动画主题演唱会的团队负责，强调“近距离的声音”。',
      '票务将于下月初开启抽选，官方同时表示会保留线上直播场次，方便海外观众参与。',
    ],
  },
  {
    id: 'jjk-final-anime',
    title: '《咒术回战》最终章动画化决定，制作阵容延续',
    date: '2026-09-21',
    author: '琉璃神社编辑部',
    section: '热门',
    summary: '官方在特别节目末尾放出最终章告知影像，确认将以剧场版形式呈现。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20cursed%20energy%20swirling%20around%20a%20Tokyo%20crossing%20at%20night%2C%20abstract%20dark%20ribbons%20of%20light%20in%20teal%20and%20amber%2C%20empty%20street%20with%20traffic%20lights%2C%20dramatic%20cinematic%20composition%2C%20painterly%20digital%20art%2C%20moody%20atmospheric%20shadows&width=800&height=600&seq=news-cursed-crossing&orientation=landscape',
    tags: ['剧场版', '咒术回战', '制作决定'],
    views: 31200,
    quote: '“故事的最后，所有人都要为自己的选择付账。”',
    content: [
      '特别节目在结尾放出了一段不到三十秒的告知影像，画面只有雨中的十字路口与逐渐扩散的黑色咒力，随后出现“最终章 剧场版制作决定”的字样。',
      '官方确认剧场版将改编原作最终段落，监督与角色设计延续电视动画阵容，动作作画部分会引入新的团队。制作方表示，剧场版的篇幅允许他们把漫画中被压缩的几场对话完整呈现。',
      '上映时间尚未公布。节目播出后，原作单行本在多个电商平台出现短期缺货。',
    ],
  },
  {
    id: 'anime-industry-report',
    title: '日本动画协会发布年度产业报告：市场规模再创新高',
    date: '2026-09-15',
    author: '琉璃神社编辑部',
    section: '专题报道',
    summary:
      '报告显示海外市场占比继续扩大，但单集制作成本上升与人才短缺仍是行业最现实的难题。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20Japanese%20animation%20industry%20office%20desk%20covered%20with%20storyboards%2C%20cels%20and%20charts%2C%20teal%20window%20light%20with%20warm%20desk%20lamp%2C%20film%20reels%20and%20coffee%20cups%2C%20editorial%20still%20life%2C%20hand%20painted%20digital%20art%2C%20detailed%20but%20clean%20composition&width=800&height=600&seq=news-industry-desk&orientation=landscape',
    tags: ['业界', '数据', '专题'],
    views: 7620,
    quote: '“规模在涨，做片子的人却越来越累。”',
    content: [
      '日本动画协会本周发布年度产业报告。数据显示，动画产业整体市场规模连续第五年增长，海外收入占比首次超过一半，流媒体版权与周边授权是主要增长来源。',
      '报告同时指出行业结构性压力：单集平均制作成本较五年前上涨约三成，而基层作画人员的平均工时并未下降。受访的三十余家制作公司中，超过半数表示“难以招募到足够的中间帧人才”。',
      '协会建议通过联合培养、工序数字化与海外协力的方式缓解压力，但也承认这些方案在短期内难以改变现场的工作强度。',
    ],
  },
  {
    id: 'shanghai-expo',
    title: '上海国际动漫展公布首批参展阵容',
    date: '2026-09-08',
    author: '琉璃神社编辑部',
    section: '最新',
    summary: '首批名单包含二十余家国内外出版社与动画公司，展会新增“独立创作者专区”。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20bright%20anime%20convention%20hall%20entrance%20with%20colorful%20banners%2C%20cosplayers%20silhouettes%2C%20confetti%20in%20the%20air%2C%20teal%20and%20amber%20lighting%2C%20lively%20festival%20atmosphere%2C%20painterly%20digital%20art%2C%20cinematic%20wide%20composition&width=800&height=600&seq=news-convention-hall&orientation=landscape',
    tags: ['展会', '活动', '国内'],
    views: 6410,
    quote: '“今年我们想把更多位置留给小桌子。”',
    content: [
      '上海国际动漫展公布首批参展阵容，共二十余家国内外出版社、动画公司与周边品牌确认参与，展期三天，场馆规模较去年扩大约两成。',
      '今年的变化是新增“独立创作者专区”，为主打个人志、原创漫画与手作的创作者提供低价展位。主办方表示，该专区报名通道开放首日便收到超过四百份申请。',
      '首批嘉宾与舞台活动将在下月陆续公布，门票采取实名预约制。',
    ],
  },
];